import {BaseIntDTO} from "../_baseIntDTO.interface";

export interface SaleTypeDTO extends BaseIntDTO {
  saleTypeName?: string;
}
